import { Flex, Typography } from 'antd';
import logo from '@Images/logo-dark.png';
import backgroundImage from '@Images/login-page-background.jpg';
import { parseDateTime } from '@Utils/transformDateTime';
import styles from './maintenance-page.module.css';

const backgroundStyle = `linear-gradient(rgba(227, 237, 247, 1), rgba(227, 237, 247, 0.4), rgba(227, 237, 247, 0)), url(${backgroundImage})`;

const MaintenancePage: React.FC = () => {
  const endTimeOfMaintenance = sessionStorage.getItem('X-Maintenance-Until');

  return (
    <Flex
      vertical
      className={styles.wrapper}
      style={{
        backgroundImage: backgroundStyle,
      }}
    >
      <Flex className={styles.innerWrapper} gap={64}>
        <img className={styles.img} src={logo} alt="logotype" />
        <div className={styles.breakLine} />
        <Flex vertical className={styles.contentWrapper} gap={10}>
          <div className={styles.title}>Maintenance Works</div>
          <Flex vertical align="center">
            Expected time end of work at
            <Typography.Title>
              <Flex vertical align="center">
                {parseDateTime(endTimeOfMaintenance || '', 'HH:mm')}
                <div style={{ fontSize: '16px' }}>
                  {parseDateTime(endTimeOfMaintenance || '')}
                </div>
              </Flex>
            </Typography.Title>
          </Flex>
          <div className={styles.description}>
            The website is currently down for maintenance.
            <br />
            We apologize for any inconveniences caused.
          </div>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MaintenancePage;
